import type { FaqItem } from '../types/content';

export const faqItems: FaqItem[] = [
  {
    question: '¿QUÉ RECIBO EXACTAMENTE?',
    answer: [
      'La oferta base incluye los 5 tomos de Maestro en Pista y los 5 bonos prácticos indicados en esta página.',
      'El Kit de Ejecución añade El Mapa de Pista y el Programador 12 Meses.'
    ]
  },
  {
    question: '¿ES UN PRODUCTO FÍSICO?',
    answer: ['No. Maestro en Pista es un producto digital.']
  },
  {
    question: '¿PUEDO CONSULTARLO DESDE EL MÓVIL?',
    answer: ['Sí. Puedes consultar el material digital desde dispositivos compatibles como móvil, tablet u ordenador.']
  },
  {
    question: '¿ME SIRVE SI ESTOY EMPEZANDO COMO MONITOR?',
    answer: [
      'Sí. La estructura está diseñada para organizar conceptos técnicos, tácticos y metodológicos de manera progresiva.'
    ]
  },
  {
    question: '¿Y SI YA TENGO EXPERIENCIA?',
    answer: [
      'En ese caso pueden resultarte especialmente útiles las áreas de metodología, planificación, diagnóstico, correcciones y organización de temporada.'
    ]
  },
  {
    question: '¿ES UN CURSO EN VÍDEO?',
    answer: ['No. Es un sistema digital de consulta y ejecución.']
  },
  {
    question: '¿CUÁL ES LA DIFERENCIA ENTRE LAS DOS VERSIONES?',
    answer: [
      'La versión de 17,90 € incluye los 5 tomos y los 5 bonos.',
      'La versión de 23,90 € añade El Mapa de Pista con 50 esquemas técnicos y el Programador 12 Meses.'
    ]
  },
  {
    question: '¿EL MATERIAL DE "VUELTA A PISTA" SUSTITUYE A UN FISIOTERAPEUTA?',
    answer: [
      'No. Es material educativo y orientativo. Ante dolor, lesión o cualquier problema de salud debe consultarse con un profesional sanitario cualificado.'
    ]
  },
  {
    question: '¿ES UNA TITULACIÓN OFICIAL?',
    answer: [
      'No. Maestro en Pista es material educativo y práctico de apoyo al trabajo del monitor y no sustituye una titulación oficial o federativa.'
    ]
  }
];
